const KEY = 'recentlyViewed';
const MAX = 12;
const EVENT = 'recently-viewed-changed';

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const pushRecent = (id) => {
  if (!id) return;
  const next = [String(id), ...getRecent().filter(x => x !== String(id))].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event(EVENT));
};

export const clearRecent = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export const RECENT_EVENT = EVENT;
